export { default } from './MagzterGoldMagazines';
